<template>
  <Breadcrumbs
      title="Vehicle Stock Report"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Vehicle Stock Report', path: '/vehicle-stock-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <dispatchSummeryForm />
    </div>
  </div>
</template>
  
<script>
import dispatchSummeryForm from "@/pages/report/vehicle_wise_stock/vehiclewisestockreporttable.vue";
export default {
  name: 'indexList',
  components: {
      dispatchSummeryForm,
  },
}
</script>
  